<script setup lang="ts">
import {ref, nextTick} from 'vue'
import MmButton from '../base/MmButton.vue'
const {t} = useI18n()
const available = useState('analytics-available', () => false)
const choice = useState('analytics-choice', () => 'unknown')
const expanded = ref(false)
const heading = ref<HTMLElement | null>(null), manage = ref<HTMLButtonElement | null>(null)
async function choose(value: string) { window.musicmintAnalytics?.setConsent(value); expanded.value = false; await nextTick(); manage.value?.focus() }
async function open() { expanded.value = true; await nextTick(); heading.value?.focus() }
</script>
<template>
  <aside v-if="available" class="analytics-consent" :aria-label="t('analyticsConsent.title')">
    <template v-if="choice === 'unknown' || expanded">
      <h2 ref="heading" tabindex="-1">{{t('analyticsConsent.title')}}</h2><p>{{t('analyticsConsent.description')}}</p>
      <div class="analytics-actions"><MmButton variant="secondary" @click="choose('denied')">{{t('analyticsConsent.reject')}}</MmButton><MmButton variant="secondary" @click="choose('granted')">{{t('analyticsConsent.allow')}}</MmButton></div>
    </template>
    <button v-else ref="manage" type="button" class="analytics-manage" @click="open">{{t('analyticsConsent.manage')}}</button>
  </aside>
</template>
<style scoped>
.analytics-consent { margin: var(--s-4) auto; padding: var(--s-4); max-width: 720px; color: var(--text-2); border-top: 1px solid var(--line); font: var(--t-small)/1.5 var(--font-ui); }
.analytics-consent h2 { color: var(--text); font: 600 var(--t-h3)/1.4 var(--font-ui); }
.analytics-actions { display: flex; flex-wrap: wrap; gap: var(--s-3); margin-top: var(--s-3); }
.analytics-manage { min-height: 44px; text-decoration: underline; text-underline-offset: var(--s-1); }
.analytics-manage:focus-visible { outline: 2px solid var(--focus); outline-offset: var(--s-1); }
</style>
